// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconNotificationPath = 'M10.931 2.467V0h-1.86v2.458c-3.322.449-5.859 3.356-5.859 6.836v3.787c0 .896-.857 1.722-1.83 1.722h-.93v1.86h6.205a3.342 3.342 0 0 0 6.684 0H19.549v-1.86h-.936c-.999-.004-1.888-.853-1.888-1.722V9.294c0-3.457-2.504-6.349-5.794-6.827ZM8.63 17.225a1.482 1.482 0 0 1-.113-.562h2.964a1.484 1.484 0 0 1-2.05 1.364 1.482 1.482 0 0 1-.801-.802Zm6.718-2.423a3.318 3.318 0 0 1-.483-1.721V9.294c0-2.802-2.213-5.036-4.896-5.036-2.684 0-4.897 2.234-4.897 5.036v3.787a3.39 3.39 0 0 1-.47 1.722h10.746Z';
var IconNotification = baseIcon('IconNotification', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconNotificationPath
});
export default IconNotification;
//# sourceMappingURL=index.js.map